<template>
  <div class="container mt-5">
    <div class="alert alert-danger text-start">
      <h4 class="alert-heading mb-2">Zugriff verweigert</h4>
      <p class="mb-3">
        F&uuml;r diesen Bereich fehlt die erforderliche Berechtigung.
      </p>
      <router-link class="btn btn-outline-secondary btn-sm" :to="{ name: 'Invoices' }">
        Zur&uuml;ck zur Rechnungs&uuml;bersicht
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForbiddenView",
};
</script>
